import axios from 'axios';
import { HEADERS } from '../../../../API/UrlAndPaths';
import store from '../../../../Redux/store';
import {
  setErrorSnack,
  setSnackMsg,
  setSuccessSnack,
} from '../../Sales/Billing/Slice/billingScreenSlice';
import { setSubmitLoading } from '../../../../Redux/Dashboard/mainDashBoardSlice';

/**
 * Search orders for correction
 * @param {Object} params - Search parameters
 * @param {string} params.branchId - Branch ID to search in
 * @param {string} params.searchType - Type of search (orderId, billNumber, customerMobile, dateRange)
 * @param {string} params.searchValue - Search value
 * @returns {Promise<Array>} - List of orders
 */
export const searchOrdersForCorrectionAPI = async ({ branchId, searchType, searchValue }) => {
  try {
    store.dispatch(setSubmitLoading(true));
    
    const result = await axios.post(
      'pos/searchOrdersForCorrection',
      { branchId, searchType, searchValue },
      HEADERS
    );

    store.dispatch(setSubmitLoading(false));

    if (result.status === 200) {
      return result.data;
    }
    return [];
  } catch (error) {
    store.dispatch(setSubmitLoading(false));
    store.dispatch(
      setSnackMsg(
        error?.response?.status === 500
          ? 'Internal server error'
          : error?.response?.data?.message || 'Failed to search orders'
      )
    );
    store.dispatch(setErrorSnack(true));
    throw error;
  }
};

/**
 * Update order with corrections
 * @param {Object} params - Update parameters
 * @param {string} params.orderId - Order ID to update
 * @param {Object} params.updates - Updated order data
 * @param {boolean} params.shiftClosed - Whether shift is closed
 * @returns {Promise<Object>} - Update result
 */
export const updateOrderCorrectionAPI = async ({ orderId, updates, shiftClosed }) => {
  try {
    store.dispatch(setSubmitLoading(true));

    const result = await axios.post(
      'pos/updateOrderCorrection',
      { orderId, updates, shiftClosed },
      HEADERS
    );

    store.dispatch(setSubmitLoading(false));

    if (result.status === 200) {
      store.dispatch(setSnackMsg('Order corrected successfully'));
      store.dispatch(setSuccessSnack(true));
      return result.data;
    }
  } catch (error) {
    store.dispatch(setSubmitLoading(false));
    store.dispatch(
      setSnackMsg(
        error?.response?.status === 500
          ? 'Internal server error'
          : error?.response?.data?.message || 'Failed to update order'
      )
    );
    store.dispatch(setErrorSnack(true));
    throw error;
  }
};

/**
 * Check if shift is closed
 * @param {Object} params - Parameters
 * @param {string} params.shiftId - Shift ID to check
 * @returns {Promise<Object>} - Shift status
 */
export const checkShiftStatusAPI = async ({ shiftId }) => {
  try {
    const result = await axios.post(
      'pos/checkShiftStatus',
      { shiftId },
      HEADERS
    );

    if (result.status === 200) {
      return result.data;
    }
    return { isClosed: false };
  } catch (error) {
    console.error('Shift status check error:', error);
    return { isClosed: false };
  }
};
